import { DotChartOutlined, TableOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';
import { IndicatorAnalyzeDisplayContainer } from 'business/shift-report/indicators/pages/indicator-analyze/components/display-container';
import { IndicatorAnalyzeFiltersProvider } from 'business/shift-report/indicators/pages/indicator-analyze/providers/filters';
import Routes from 'config/routes';

import { MobileIndicatorAnalyzeFilters } from './components/filters';

export const MobileIndicatorAnalyzePage = () => {
  const { t } = useTranslation();

  const [showTable, setShowTable] = useState(false);

  return (
    <SingleGraphReferenceContextProvider>
      <IndicatorAnalyzeFiltersProvider>
        <MobileSingleCardPageWithFilterLayout
          title={t('pages.manager.indicators.title')}
          filters={<MobileIndicatorAnalyzeFilters />}
          corner={
            <Switch
              value={showTable}
              onChange={(value) => setShowTable(value)}
              checkedChildren={<TableOutlined />}
              unCheckedChildren={<DotChartOutlined />}
            />
          }
          mainPageRedirection={Routes.ReportDashboardAnalyze}
        >
          <IndicatorAnalyzeDisplayContainer showTable={showTable} />
        </MobileSingleCardPageWithFilterLayout>
      </IndicatorAnalyzeFiltersProvider>
    </SingleGraphReferenceContextProvider>
  );
};
